import React from 'react';
import { Translate } from '../../language';
import Button from '../../utils/components/Button/Button';
import Options from '../../utils/components/Options/Options';
import { Switch } from "react-router-dom";
import ModalReportPost from '../ReportContent/ModalReportPost';
import circle from "../../assets/img/circulogris.png";
import { useHistory } from "react-router-dom";

import ImageNameDescription from '../../utils/components/ImageNameDescription/ImageNameDescription';
import { RouteWithSubRoutes } from '../../config/Router';
import NewPost from '../Post/NewPost/NewPost';
import TabZone from './TabZone/TabZone';
import useModal from '../../utils/hooks/useModal';
import style from "./Zones.module.css"
const Zone = ({ zone, exitZone, routes, isLoading, inCommunity, sendRequest, aceptInvite }) => {
  const [refExit, isShowExit, setIsShowExit] = useModal(false)
  const history = useHistory();
  if (isLoading) {
    return (
      <div className={style.content_error}>
        <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      </div>
    )
  }
  if (zone.isError) {
    return (
      <div className={style.content_error}>No encontrado</div>
    )
  }
  const adminType = zone.adminType
  return (
    <div className="content-profile">
      <div
        style={{ overflow: "auto" }}
        className={`content-profile-info scroll-menu`}
      >

        <Options
          type={`vertical`}
          options={[

          ]}
        />
        <img
          alt="img"
          className={`profile-picture-img`}
          onError={(e) => (e.target.src = circle)}
          src={(zone.picture && zone.picture.url) ? zone.picture.url.origin : circle}
        ></img>
        <div
          style={{ overflow: "auto", overflowY: "hidden" }}
          className="full-name-image-name full-name-profile scroll-menu"
        >
          <div className={`first-name-image-name`}>{zone?.name}</div>
          <div className={`second-name-image-name`}>{ }</div>
        </div>
        <div className={`slogan-profile`}>{zone?.description}</div>
        <div className="content-social-data-profile">
          <div className="content-social-data-info">
            <div className={`text-social-data`}>
              {zone?.members}
            </div>
            <div className={`text-color-green`}>
              {Translate("members", "es")}
            </div>
          </div>



        </div>
        <div>
          {
            adminType ==="user" && <ImageNameDescription
              srcImage={zone?.adminUserId?.picture && zone.adminUserId?.picture.url ? zone?.adminUserId?.picture.url.small : zone?.adminUserId?.picture}
              firstName={zone?.adminUserId?.name.split(" ")[0]}
              secondName={zone?.adminUserId?.lastname.split(" ")[0]}
              description={"Administrador"}
            />
          }
          {
            adminType ==="franchise" && <ImageNameDescription
              srcImage={zone?.adminFranchiseId?.picture && zone.adminFranchiseId?.picture.url ? zone?.adminFranchiseId?.picture.url.small : zone?.adminFranchiseId?.picture}
              firstName={zone?.adminFranchiseId?.socialReason}

              description={"Administrador"}
            />
          }
          {
            adminType ==="warehouse" && <ImageNameDescription
              srcImage={zone?.adminWarehouseId?.profileId?.picture && zone.adminWarehouseId?.profileId?.picture.url ? zone?.adminWarehouseId?.profileId?.picture.url.small : zone?.adminWarehouseId?.profileId?.picture}
              firstName={zone?.adminWarehouseId?.name}

              description={"Administrador"}
            />
          }
          {
            adminType ==="representative" && <ImageNameDescription
              srcImage={zone?.adminRepresentativeId?.userID?.picture && zone.adminRepresentativeId?.userID?.picture.url ? zone?.adminRepresentativeId?.userID?.picture.url.small : zone?.adminRepresentativeId?.userID?.picture}
              firstName={zone?.adminRepresentativeId?.userID?.name}

              description={"Administrador"}
            />
          }
        </div>

        <div className={`footer-profile-info`}>
          {inCommunity?.isAdmin &&
            <Button text='Administrar zona' onClick={() => {
              history.push(`/Zones/Admin/${zone._id}`)
            }} />
          }
          {
            !inCommunity?.isAdmin && <>
              {
                (inCommunity?.status ===2) && <Button text='Dejar zona' onClick={() => setIsShowExit(true)} />
              }
              {(inCommunity?.status ===0 && inCommunity?.invitation) && <Button text='Aceptar invitación' onClick={() => aceptInvite()} />}
              {(inCommunity?.status ===0 && !inCommunity?.invitation) && <Button text='Esperando aprobación' onClick={() => { }} />}
              {(inCommunity ===null) && <Button text='Enviar solicitud' onClick={() => { sendRequest() }} />}


            </>

          }


          <ModalExit exitZone={exitZone} displayModal={isShowExit} close={() => setIsShowExit(false)} />
        </div>
      </div>
      <div className="content-profile-navegation">
        {
          (inCommunity?.status ===2) ? <>
            <div className="content-new-post-tab-bar">
              {!history.location.pathname.split("/")[4] && <NewPost zone={zone} show={(inCommunity?.status ===2)} />}
              <TabZone _id={zone?._id} />
            </div>
            <Switch>
              {routes.map((route, i) => (
                <RouteWithSubRoutes key={i} {...route} />
              ))}
            </Switch>
          </> :


            <div className='modal-content'>
              Esta es una comunidad privada,
              necesitas ser miembro de ella

              para ver su contenido
            </div>


        }
      </div>
    </div>

  )
};
const ModalExit = ({ exitZone, close, displayModal }) => {
  const divStyle = {
    display: displayModal ? 'block' : 'none'
  }
  return (
    <div
      className={"modal"}
      style={divStyle}
      onClick={close}>
      <div className="modal-content">
        <div className='column centerContent centerItems'>Desea abandonar la zona</div>
        <div className='column spaceAround'>
          <Button
            text='Si'
            onClick={exitZone}
          />
          <Button
            text='no'
            onClick={close}
          />
        </div>
      </div>
    </div>
  )
}

export default Zone;
